document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll(".product-gallery-section");

  galleries.forEach((gallery) => {
    const listItems = gallery.querySelectorAll(".list-product-item");
    const featuredItems = gallery.querySelectorAll(".featured-product-item");

    listItems.forEach((item) => {
      item.addEventListener("click", function () {
        const productId = this.getAttribute("data-product");

        // Remove active class from all list items in this gallery
        listItems.forEach((listItem) => {
          listItem.classList.remove("active");
        });

        // Add active class to the clicked list item
        this.classList.add("active");

        // Remove active class from all featured items in this gallery
        featuredItems.forEach((featuredItem) => {
          featuredItem.classList.remove("active");
          featuredItem.setAttribute("aria-hidden", "true");
        });

        // Add active class to the matching featured item in this gallery
        const matchingFeaturedItem = gallery.querySelector(
          `.featured-product-item[data-product="${productId}"]`
        );
        if (matchingFeaturedItem) {
          matchingFeaturedItem.classList.add("active");
          matchingFeaturedItem.setAttribute("aria-hidden", "false");
        }
      });
    });
  });
});
